export default function registerApproval (lf) {
  lf.register('approval', ({ RectNode, RectNodeModel, h }) => {
    class View extends RectNode {

      getLabelShape() {
        const { model } = this.props;
        const { x, y, width, height } = model;
        const style = model.getNodeStyle();
        return h(
            "svg",
            {
              x: x - width / 2 + 5,
              y: y - height / 2 + 5,
              width: 25,
              height: 25,
              viewBox: "0 0 1274 1024"
            },
            [
              h("path", {
                fill: style.stroke,
                d:
                    "M605.09 599.924h3.887a65.932 65.932 0 0 1 65.932 65.909H372.364a65.932 65.932 0 0 1 65.931-65.932h3.887V495.64c-14.546-7.54-23.273-17.152-23.273-27.624 0-1.955 0.303-3.887 0.908-5.795-56.413-32.885-93.999-91.811-93.999-159.023 0-103.191 88.576-186.833 197.818-186.833s197.819 83.642 197.819 186.833c0 67.212-37.586 126.138-93.999 159.046a19.27 19.27 0 0 1 0.908 5.818c0 10.45-8.728 20.061-23.273 27.602v104.261zM232.728 709.818h558.546a93.09 93.09 0 0 1 93.09 93.091v58.182a46.545 46.545 0 0 1-46.545 46.545H186.182a46.545 46.545 0 0 1-46.546-46.545v-58.182a93.09 93.09 0 0 1 93.091-93.09z"
              })
            ]
        );
      }
      getShape() {
        const { model } = this.props;
        const { x, y, width, height, radius, properties } = model;
        const style = model.getNodeStyle();
        return h("g", {}, [
          h("rect", {
            ...style,
            x: x - width / 2,
            y: y - height / 2,
            rx:radius,
            ry: radius,
            width,
            height
          }),
          this.getLabelShape()
        ]);
      }
    }
    class Model extends RectNodeModel {
      constructor (data, graphModel) {
        super(data, graphModel)
        this.radius = 0;
      }
    }
    return {
      view: View,
      model: Model
    }
  })
}
